export default __webpack_public_path__ + "static/media/Support.4aeb4804.png";